export const sortInstallmentByDate = installments => {
  if (installments) {
    return installments.sort((a, b) => (a?.dueDate < b?.dueDate ? -1 : a?.dueDate > b?.dueDate ? 1 : 0))
  }
}
